import Home from "./Home";
import { EarlyAccessDialog } from "@/components/EarlyAccessDialog";

const EarlyAccess = () => (
  <>
    <Home />
    <EarlyAccessDialog defaultOpen />
  </>
);

export default EarlyAccess;
